import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

// Hooks

import GetMunicipalityOfficesByState from '../../../../../hooks/GetMunicipalityOfficesByState';
import GetOfficesByMunicipality from '../../../../../hooks/GetOfficesByMunicipality';

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import CurrencyInput from '../../../../UI/FormInput/CurrencyInput';
import DropDownInput from '../../../../UI/FormInput/DropDownInput';
import NumberInput from '../../../../UI/FormInput/NumberInput';
import RadioInput from '../../../../UI/FormInput/RadioInput';
import FormInputGroup from '../../../../UI/FormInputGroup/FormInputGroup';
import Button from '../../../../UI/Button/Button';

// Utilities

import { formatAccountProductOptions, formatDropDownOptions, formatDropDownOptionsAlt } from '../../../../../utilities/helper-functions';

// Constants

import { MAX_CURRENCY_INPUT_DIGITS, CURRENCY_SYMBOLS, ACCOUNT_CATEGORY_ID, ACCOUNT_PRODUCT_NAMES } from '../../../../../config/constants';
import { initialValues } from '../InitialValues';

export default function ProductCurrencies({ formik, goToPreviousModule }) {
    const {
        getMunicipaltiesWithOfficesIsLoading,
        getMunicipaltiesWithOfficesError,
        municipaltiesWithOffices,
        handleGetMunicipaltiesWithOfficesByState,
    } = GetMunicipalityOfficesByState();
    const { getOfficesIsLoading, getOfficesError, offices, handleGetOfficesByMunicipality } = GetOfficesByMunicipality();

    // Dropdown Options
    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);


    // Set selected products currencies and total income

    useEffect(() => {
        // Set total income
        let incomeSum = 0;

        if (formik.values?.jobReferences?.hasJob === 'si' || formik.values?.jobReferences?.hasIncome === 'si' || formik.values?.jobReferences?.hasBusiness === 'si') {
            const jobSalary = formik.values?.jobReferences?.hasJob === 'si' ? formik.values?.jobReferences?.empleo?.sueldoMensual : 0;
            const incomeSalary = formik.values?.jobReferences?.hasIncome === 'si' ? formik.values?.jobReferences?.ingreso?.montoEstimado : 0;
            const businessSalary = formik.values?.jobReferences?.hasBusiness === 'si' ? formik.values?.jobReferences?.negocioPropio?.ingresos : 0;
            incomeSum = jobSalary + incomeSalary + businessSalary;

            if (incomeSum > 0) {
                formik.setFieldValue('movilizacionProductos.totalIngresos', incomeSum);
            } else {
                formik.setFieldValue('movilizacionProductos.totalIngresos', 0);
            }
        } else {
            if (['5', '6'].includes(formik.values?.cliente?.tipoCliente)) {
                incomeSum = formik.values?.cliente?.montoEstimadoDeIngreso;
                formik.setFieldValue('movilizacionProductos.totalIngresos', incomeSum);
            } else {
                formik.setFieldValue('movilizacionProductos.totalIngresos', 0);
            }
        }

        // Set selected products values

        if (formik?.values?.selectedProducts?.length > 0 && !formik?.values?.productFunds[0]?.nombreProducto) {
            let productFunds = [];

            const lowestRange = dropDownOptions?.data?.depositWithdrawalRanges?.find(
                (item) => item.value === 1
            );

            let productsToUse = [...formik.values.selectedProducts];

            const hasMyCurrentAccount = productsToUse.some(
                (item) =>
                    item.label === ACCOUNT_PRODUCT_NAMES.myCurrentAccount &&
                    item.categoryId === ACCOUNT_CATEGORY_ID.currentAccount
            );

            const hasLevelOneAccount = productsToUse.some(
                (item) => 
                    item.label === ACCOUNT_PRODUCT_NAMES.currentLevelOneAccount &&
                    item.categoryId === ACCOUNT_CATEGORY_ID.currentAccount
            );

            if (!hasMyCurrentAccount && !hasLevelOneAccount) {

                const currentAccountProducts = formatAccountProductOptions(
                    dropDownOptions?.data?.currentAccountProducts,
                    ACCOUNT_CATEGORY_ID.currentAccount
                );

                const myCurrentAccountProduct = currentAccountProducts.find(
                    (item) => item.label === ACCOUNT_PRODUCT_NAMES.myCurrentAccount
                );

                if (myCurrentAccountProduct) {
                    productsToUse.push(myCurrentAccountProduct);
                }
            }

            productsToUse.forEach((prod) => {

                let product = {
                    ...initialValues?.productFunds[0],
                    nombreProducto: prod?.label,
                    monedaProducto: prod?.moneda,
                    categoriaProducto: prod?.categoryId,
                    idDelProducto: prod?.value,
                    totalIngresos: incomeSum,
                    descripcionMontDep: incomeSum > 0 ? '' : lowestRange?.name,
                    descripcionMontRet: incomeSum > 0 ? '' : lowestRange?.name,
                };

                productFunds.push(product);

            });

            formik?.setFieldValue('productFunds', productFunds);
        } else if (formik?.values?.productFunds[0]?.nombreProducto) {
            let productFunds = [];
            const lowestRange = dropDownOptions?.data?.depositWithdrawalRanges?.find((item) => item.value === 1);

            formik?.values?.productFunds?.forEach((prod) => {
                let product = {
                    ...prod,
                    totalIngresos: incomeSum,
                    descripcionMontDep: incomeSum > 0 ? prod?.descripcionMontDep : lowestRange?.name,
                    descripcionMontRet: incomeSum > 0 ? prod?.descripcionMontRet : lowestRange?.name,
                }
                productFunds.push(product);
            });
            formik?.setFieldValue('productFunds', productFunds);
        }
    }, [formik?.values?.selectedProducts, formik.values?.jobReferences])


    // Get the Municipalities by State

    useEffect(() => {
        if (formik.values?.movilizacionProductos?.entidad) {
            // formik.setFieldValue('movilizacionProductos.ciudad', '')
            // formik.setFieldValue('cliente.oficinaAsesor', '')
            handleGetMunicipaltiesWithOfficesByState(formik.values?.movilizacionProductos?.entidad);
        }
    }, [handleGetMunicipaltiesWithOfficesByState, formik.values?.movilizacionProductos?.entidad]);

    // Get the Offices by Municipality

    useEffect(() => {
        if (formik.values?.movilizacionProductos?.ciudad) {
            // formik.setFieldValue('cliente.oficinaAsesor', '');
            handleGetOfficesByMunicipality(formik.values?.movilizacionProductos?.ciudad);
        }
    }, [handleGetOfficesByMunicipality, formik.values?.movilizacionProductos?.ciudad])

    return (
        <>
            <SectionHeading text={'¿Como sera la movilización de tus productos por tipo de moneda?'} />

            {formik.values?.productFunds?.map((productFund, index) => (
                <div key={index}>

                    <h3 className="multiple-input-heading">Producto "{productFund?.nombreProducto}"</h3>

                    <SectionHeading text={`Información sobre movilización de fondos en ${CURRENCY_SYMBOLS[productFund?.monedaProducto]}`} isSubHeading />

                    <FormInputGroup>

                        <NumberInput
                            formik={formik}
                            fieldName={`productFunds.${index}.cantDepositos`}
                            label={'Cantidad de depósitos a realizar'}
                            isRequired={true}
                            max={999}
                            min={0}
                            maxLength={3}
                        />

                        <NumberInput
                            formik={formik}
                            fieldName={`productFunds.${index}.cantRetiros`}
                            label={'Cantidad de retiros a realizar'}
                            isRequired={true}
                            max={999}
                            min={0}
                            maxLength={3}
                        />

                        <CurrencyInput
                            formik={formik}
                            fieldName={`productFunds.${index}.montoPromedio`}
                            label={'Monto promedio mensual'}
                            isRequired={true}
                            max={MAX_CURRENCY_INPUT_DIGITS}
                        />

                    </FormInputGroup>

                    <SectionHeading text={'Uso de productos'} isSubHeading />

                    <FormInputGroup>

                        <DropDownInput
                            formik={formik}
                            fieldName={`productFunds.${index}.descripcionMontDep`}
                            label={'Rango monto depositos'}
                            options={formatDropDownOptionsAlt(dropDownOptions?.data?.depositWithdrawalRanges)}
                            isRequired={true}
                            disabled={formik.values?.movilizacionProductos?.totalIngresos === 0}
                        />

                        <DropDownInput
                            formik={formik}
                            fieldName={`productFunds.${index}.descripcionMontRet`}
                            label={'Rango monto retiros'}
                            options={formatDropDownOptionsAlt(dropDownOptions?.data?.depositWithdrawalRanges)}
                            isRequired={true}
                            disabled={formik.values?.movilizacionProductos?.totalIngresos === 0}
                        />

                        <DropDownInput
                            formik={formik}
                            fieldName={`productFunds.${index}.motivoApertura`}
                            label={'Motivo de la apertura'}
                            options={formatDropDownOptions(dropDownOptions?.data?.reasonForOpenings)}
                        />

                        <DropDownInput
                            formik={formik}
                            fieldName={`productFunds.${index}.origenFondos`}
                            label={'Origen de los fondos '}
                            options={formatDropDownOptions(dropDownOptions?.data?.sourceOfFunds)}
                        />

                        <DropDownInput
                            formik={formik}
                            fieldName={`productFunds.${index}.destinoFondos`}
                            label={'Destino de los fondos'}
                            options={formatDropDownOptions(dropDownOptions?.data?.destinationOfFunds)}
                        />

                    </FormInputGroup>

                    <SectionHeading text={'Origen y Destinos de fondos'} isSubHeading />

                    <FormInputGroup>

                        <DropDownInput
                            formik={formik}
                            fieldName={`productFunds.${index}.paisOrigen`}
                            label={'¿Recibir fondos desde?'}
                            options={formatDropDownOptions(dropDownOptions?.data?.countries)}
                            disabled
                        />

                        <DropDownInput
                            formik={formik}
                            fieldName={`productFunds.${index}.paisDestino`}
                            label={'¿Envías fondos hacia?'}
                            options={formatDropDownOptions(dropDownOptions?.data?.countries)}
                            disabled
                        />

                    </FormInputGroup>

                    <FormInputGroup>

                        <RadioInput
                            formik={formik}
                            fieldName={`productFunds.${index}.usaMonedaVirtual`}
                            label={'¿Movilizará el producto para adquirir o vender moneda virtual?'}
                            options={[{ label: 'Sí', value: 'si' }, { label: 'No', value: 'no' }]}
                            isGroup={true}
                            isRequired={true}
                        />

                        {formik.values?.productFunds[index]?.usaMonedaVirtual === 'si' &&
                            <DropDownInput
                                formik={formik}
                                fieldName={`productFunds.${index}.monedaVirtual`}
                                label={'Indique el nombre de la moneda virtual'}
                                options={formatDropDownOptions(dropDownOptions?.data?.virtualCurrencies)}
                            />}

                    </FormInputGroup>

                </div>))}


            <SectionHeading text={'Selecciona la oficina de tu preferencia'} hideRequiredFieldsMessage />

            <FormInputGroup>
                <DropDownInput
                    formik={formik}
                    fieldName={'movilizacionProductos.entidad'}
                    label={'Estado'}
                    options={formatDropDownOptions(dropDownOptions?.data?.stateThatHaveOffices)}
                    isRequired={true}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'movilizacionProductos.ciudad'}
                    label={'Municipio'}
                    options={formatDropDownOptions(municipaltiesWithOffices)}
                    isRequired={true}
                    disabled={municipaltiesWithOffices?.length === 0 || getMunicipaltiesWithOfficesIsLoading || getMunicipaltiesWithOfficesError}
                    loading={getMunicipaltiesWithOfficesIsLoading}
                />

                <DropDownInput
                    formik={formik}
                    fieldName={'cliente.oficinaAsesor'}
                    label={'Oficina'}
                    options={formatDropDownOptions(offices)}
                    isRequired={true}
                    disabled={offices?.length === 0 || getOfficesIsLoading || getOfficesError}
                    loading={getOfficesIsLoading}
                />

            </FormInputGroup>

            <div className='form-actions'>

                <Button
                    action={() => goToPreviousModule(2)}
                    label={'Regresa'}
                    secondaryStyle={true}
                />

                <Button
                    type="submit"
                    action={formik.handleSubmit}
                    label={'Continua'}
                />

            </div>
        </>
    )
}
